import { css } from '@emotion/core';

export default {
  img: css`
    max-height: 40px;
    height: 100%;
    max-width: 100%;
  `,
  container: css`
    // fix the height of the containter to match the image.
    // The spinner is shorter than the image, so without this, there is a
    // visible re-layout when switching between image and spinner.
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  button: css`
    height: 40px;
    display: flex;
    background: none;
    border: none;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  `,
};
